import { c as _c } from "react/compiler-runtime";
import { SiNextdotjs } from '@icons-pack/react-simple-icons';
import { HeartIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
export function FavoriteFramework() {
  const $ = _c(8);
  const t = useTranslations();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <HeartIcon className="size-4.5" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("homepage.about-me.fav-framework");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex items-center gap-2">{t0}<h2 className="text-sm">{t1}</h2></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center justify-center"><SiNextdotjs size={80} /></div>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <div className="flex flex-col gap-6 rounded-2xl p-4 shadow-feature-card lg:p-6">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}